import { PRODUTOS, type IdProduto, type Produto } from '../../../dominio/produtos'

interface Props {
  idSelecionado: IdProduto
  aoSelecionar: (id: IdProduto) => void
  /** Só oferece produtos que fazem sentido na oficina (ex.: BLEVE só com gás liquefeito). */
  filtro?: (produto: Produto) => boolean
  /** Explica por que um produto filtrado ficou fora, em vez de escondê-lo. */
  motivoIndisponivel?: (produto: Produto) => string | null
}

export function SeletorProduto({ idSelecionado, aoSelecionar, filtro, motivoIndisponivel }: Props) {
  return (
    <div className="grupo-controle">
      <span className="titulo-controle">Produto transportado</span>
      <div className="seletor-produto" role="radiogroup" aria-label="Produto transportado">
        {PRODUTOS.filter((p) => !filtro || filtro(p)).map((produto) => {
          const motivo = motivoIndisponivel?.(produto) ?? null
          const ativo = produto.id === idSelecionado
          return (
            <button
              key={produto.id}
              type="button"
              role="radio"
              aria-checked={ativo}
              disabled={motivo != null}
              title={motivo ?? `ONU ${produto.onu} — guia ${produto.guiaGre.valor}`}
              className={`btn-acao-cad ${ativo ? 'btn-acao-cad--primario' : 'btn-acao-cad--secundario'}`}
              onClick={() => aoSelecionar(produto.id)}
            >
              <span className="seletor-produto__onu">{produto.onu}</span>
              {produto.nome}
            </button>
          )
        })}
      </div>
    </div>
  )
}
